// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7dcc98b3","396":"65f99b18","397":"76a40ee7","453":"291bedd2","455":"ea8a743d","977":"b81f1b59"}[chunkId] + ".chunk.js";
};